import React from 'react';
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';
import ServiceCard from './service-card';

const Services = () => {
  const { t } = useTranslation();

  const services = [
    {
      id: 1,
      title: t('services.software.title'),
      description: t('services.software.description'),
      image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 2,
      title: t('services.web.title'),
      description: t('services.web.description'),
      image: 'https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 3,
      title: t('services.security.title'),
      description: t('services.security.description'),
      image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 4,
      title: t('services.consulting.title'),
      description: t('services.consulting.description'),
      image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 5,
      title: t('services.cloud.title'),
      description: t('services.cloud.description'),
      image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 6,
      title: t('services.ai.title'),
      description: t('services.ai.description'),
      image: 'https://images.unsplash.com/photo-1488229297570-58520851e868?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
    }
  ];

  return (
    <div className="container my-5">
      <MDBRow className='row-cols-1 row-cols-md-2 row-cols-lg-3 g-4'>
        {services.map((service) => (
          <MDBCol key={service.id}>
            <ServiceCard
              title={service.title}
              description={service.description}
              image={service.image}
            />
          </MDBCol>
        ))}
      </MDBRow>
    </div>
  );
};

export default Services;
